import './common'
import axios from 'axios'

export default {
    getAreas: (params) => axios.get('/areas', { params }),
    createArea: (data) => axios.post('/areas', data),
    updateArea: (data) => axios.put(`/areas/${data.ID}`, data),
    getAreasAttendance: (areas) => axios.get('/areas-attendance', { params: { AreaID: areas } })
}
